import axios from "axios";
import {
  Client,
  ClientAttributionConfiguration,
  ClientConnect,
  CreateClient,
  EditClient,
  EditClientConnect,
  HereDotcomAccount,
} from "../../Types/ClientManagement";

export const getAllClients = async () => {
  const res = await axios.get<Client[]>(import.meta.env.VITE_BACKEND_API + "/api/client");
  return res.data;
};

export const getHereDotComAccounts = async () => {
  try {
    const res = await axios.get<HereDotcomAccount[]>(
      import.meta.env.VITE_BACKEND_API + "/api/client/heredotcomaccounts",
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return [] as HereDotcomAccount[];
  }
};

export const editClient = async (clientId: string, jsonData: EditClient) => {
  try {
    await axios.put(import.meta.env.VITE_BACKEND_API + "/api/client/edit/" + clientId, jsonData, {
      headers: {
        "Content-Type": "application/json",
        client: clientId,
      },
    });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const createClient = async (jsonData: CreateClient) => {
  try {
    const res = await axios.post(import.meta.env.VITE_BACKEND_API + "/api/client/create", jsonData, {
      headers: {
        "Content-Type": "application/json;",
      },
      responseType: "blob",
    });
    const url_2 = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url_2;
    const contentDisposition = res.headers["content-disposition"];
    const filename = contentDisposition.substring(21);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const deleteClient = async (clientId: string) => {
  try {
    await axios.delete(import.meta.env.VITE_BACKEND_API + "/api/client/delete/" + clientId, {
      headers: {
        "Content-Type": "application/json;",
        client: clientId,
      },
    });
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getClientConnect = async (clientId: string) => {
  try {
    const res = await axios.get<ClientConnect>(
      import.meta.env.VITE_BACKEND_API + "/api/client/ClientConnect/" + clientId,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {} as ClientConnect;
  }
};

export const editClientConnect = async (editedClient: EditClientConnect) => {
  try {
    const res = await axios.put<boolean>(
      import.meta.env.VITE_BACKEND_API + "/api/client/EditClientConnect",
      editedClient,
      {
        headers: {
          "Content-Type": "application/json;",
          client: editedClient.clientId,
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getAttribution = async (clientId: string) => {
  try {
    const res = await axios.get<ClientAttributionConfiguration>(
      import.meta.env.VITE_BACKEND_API + "/api/client/getAttribution/" + clientId,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {} as ClientAttributionConfiguration;
  }
};

export const saveAttribution = async (attribution: ClientAttributionConfiguration) => {
  try {
    const res = await axios.post<ClientAttributionConfiguration>(
      import.meta.env.VITE_BACKEND_API + "/api/client/saveAttribution",
      attribution,
      {
        headers: {
          "Content-Type": "application/json;",
          client: attribution.clientId,
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {} as ClientAttributionConfiguration;
  }
};

export const indexClient = async (clientId: string) => {
  try {
    const res = await axios.post(import.meta.env.VITE_BACKEND_API + "/api/client/index/" + clientId, {});
    return res.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};
